// extracted by mini-css-extract-plugin
export default {"container":"DrinkSelector_container__hlinv","drink":"DrinkSelector_drink__DqAYj","tabs":"DrinkSelector_tabs__PJuYi","spin":"DrinkSelector_spin__U3xJn"};